export default {
  'bindTo': 'this',
  'method': function(){
    alert('Lettera Benvenuto')
  },
}
